/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react'
import { FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n, Decrypt } from 'utilities/utilities';
import { Grid, Typography } from '@mui/material';
import { BtnBack, BtnBaseButton, BtnDraft, BtnSave } from 'components/Button/ButtonAll';
import _ from "lodash";
import moment from 'moment';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { I18NextNs } from 'enum/enum';
import { TableIncome } from './TableIncome';
import InputNumberItem from 'components/Input/InputNumber';
import { ItemFundAcc } from './interfaceFundAcc';
import { TableMoreDetail } from './TableMoreDetail';
import { TableExpense } from './TableExpense';
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';
import { parseFloatCheckValue } from '../Ticket/fnTickit';
import InputReactNumber from '../InputReactNumber';

export const ProviderFundAccount = React.createContext(null);

export interface IproviderFundAcc {
    isView: boolean;
    isSubmit: boolean
    DialogFn: any;
    optionExpense: any[];
    findValue: (arrList: any, fieldChildren: any, fieldValue: any, value: any) => any;
    findMaxID: (lstData: any) => number;
    handleSelectExpense: (value: any) => Promise<number>
    setEqualBalance: React.Dispatch<React.SetStateAction<boolean>>
    form: UseFormReturn<{
        dDate: any;
        sBringForward: any;
        sTotalIncome: any;
        sTotalExpense: any;
        sTotalMoreDetail: any;
        sBalance: any;
        lstIncome: ItemFundAcc[];
        lstExpense: ItemFundAcc[];
        lstMoreDetail: ItemFundAcc[];
    }, any, undefined>
}

export interface LstOptionExpense {
    value: number
    label: string
    nOrder: number
    nFundExpenseID: any
}

const FundAccoutingForm = () => {


    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs: string = Decrypt(new URLSearchParams(location.search).get("nPermision")) ?? "2";
        return { ParamId, ParamPrs }
    }, [location.search])

    const isView = useMemo(() => {
        const ParamPrs: string = Decrypt(new URLSearchParams(location.search).get("nPermision")) ?? "2";
        return ParamPrs === "1"
    }, [location.search])

    //#region State / Usememo
    // const [isView, setIsView] = useState<boolean>(false)
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    const [isValueDate, setIsValueDate] = useState<boolean>(false)
    const [optionExpense, setOptionExpense] = useState<LstOptionExpense[]>([])
    const [equalBalance, setEqualBalance] = useState<boolean>(true)

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dDate: null,
            sBringForward: null,
            sTotalIncome: null,
            sTotalExpense: null,
            sTotalMoreDetail: null,
            sBalance: null,
            lstIncome: [],
            lstExpense: [],
            lstMoreDetail: [],
        }
    });
    // #endregion

    useEffect(() => {
        getOptionInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getOptionInitialData = async () => {
        if (!objParamPath.ParamId) return;

        DialogFn.BlockUI();
        await AxiosFn.Get(`FundAccounting/GetFormInfoFundAccount`, { sID: objParamPath.ParamId }, (result: { objResult: any; }) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (objResult) {
                setIsValueDate(true)
                setIsSubmit(objResult.isSubmitted)
                setOptionExpense(objResult.lstOptionExpense || [])
                form.setValue("dDate", moment(objResult.dFundAccounting))
                form.setValue("sBringForward", objResult.nBringForward + "")
                form.setValue("sTotalIncome", objResult.nTotalIncome + "")
                form.setValue("sTotalExpense", objResult.nTotalExpense + "")
                let sumMoreDetail = _.sumBy(objResult.lstMoreDetail, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                sumMoreDetail = Number(sumMoreDetail.toFixed(2));
                form.setValue("sTotalMoreDetail", sumMoreDetail + "")
                form.setValue("sBalance", objResult.nBalance + "")
                form.setValue("lstIncome", objResult.lstIncome)
                form.setValue("lstExpense", objResult.lstExpense)
                form.setValue("lstMoreDetail", objResult.lstMoreDetail)
                form.reset({
                    ...form.watch(),
                });

                setEqualBalance(objResult.nBalance === sumMoreDetail)

            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const gotoBack = () => {
        Router.GoToPage("/FundAccoutingList")
    }

    const ReCalculateValue = () => {
        if (!objParamPath.ParamId) return;

        DialogFn.BlockUI();
        AxiosFn.Get(`FundAccounting/ReCalculateValue`, { sID: objParamPath.ParamId }, (result: { objResult: any; }) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (objResult) {
                setIsValueDate(true)
                setIsSubmit(objResult.isSubmitted)
                setOptionExpense(objResult.lstOptionExpense || [])
                form.setValue("dDate", moment(objResult.dFundAccounting))
                form.setValue("sBringForward", objResult.nBringForward + "")
                form.setValue("sTotalIncome", objResult.nTotalIncome + "")
                form.setValue("sTotalExpense", objResult.nTotalExpense + "")
                let sumMoreDetail = _.sumBy(objResult.lstMoreDetail, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                sumMoreDetail = Number(sumMoreDetail.toFixed(2));
                form.setValue("sTotalMoreDetail", sumMoreDetail + "")

                let calBalance = objResult.nBringForward + objResult.nTotalIncome - objResult.nTotalExpense;

                form.setValue("sBalance", calBalance + "")
                form.setValue("lstIncome", objResult.lstIncome)
                form.setValue("lstExpense", objResult.lstExpense)
                form.setValue("lstMoreDetail", objResult.lstMoreDetail)
                form.reset({
                    ...form.watch(),
                });

                setEqualBalance(calBalance === sumMoreDetail)

            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSubmitForm = (sMode: "D" | "S") => {

        if (sMode === "S" && !equalBalance) {
            DialogFn.Warning("ยอดเงินไม่ถูกต้อง");
            return;
        }

        let dataForm = form.getValues();

        let objParam = {
            sMode: sMode,
            sIDFundAcc: objParamPath.ParamId,
            dDate: dataForm.dDate ? moment(dataForm.dDate).valueOf() : null,
            sBringForward: dataForm.sBringForward + "",
            sTotalIncome: dataForm.sTotalIncome + "",
            sTotalExpense: dataForm.sTotalExpense + "",
            sBalance: dataForm.sBalance + "",
            lstIncome: dataForm.lstIncome,
            lstExpense: dataForm.lstExpense,
            lstMoreDetail: dataForm.lstMoreDetail,
        };

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`FundAccounting/OnSubmitFundAccount`, objParam, () => {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    gotoBack();
                });
            });
        });
    }

    const handleSelectYear = async (eValue: moment.MomentInput) => {
        form.clearErrors();
        if (!eValue) {
            setIsValueDate(false)
            form.setValue("lstIncome", [])
            form.setValue("lstExpense", [])
            form.setValue("lstMoreDetail", [])
            return;
        }
        setIsValueDate(true)
        DialogFn.BlockUI();
        let dDateIncome = moment(eValue).valueOf();
        await AxiosFn.Get(`FundAccounting/GetFormInitialFundAccount`, { sID: objParamPath.ParamId, nDate: dDateIncome }, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === 203) {
                setIsValueDate(false)
                DialogFn.Warning(result.sMessage);
                return;
            }

            let objResult = result.objResult;
            if (objResult) {
                form.setValue("sBringForward", objResult.nBringForward + "")
                let lstIncome = objResult.lstIncome || [];
                lstIncome.forEach((element: ItemFundAcc, index: number) => {
                    if (element.lstSubLevel != null && element.lstSubLevel.length !== 0) {
                        let sum = _.sumBy(element.lstSubLevel, function (o: ItemFundAcc) { return parseFloatCheckValue(o.sTotal); });
                        element.sTotal = sum + "";
                        form.setValue(`lstIncome.${index}.sTotal`, sum + "")
                    }
                });
                let sumIncome = _.sumBy(lstIncome, (o: ItemFundAcc) => { return parseFloatCheckValue(o.sTotal); });
                form.setValue("sTotalIncome", sumIncome + "")

                let lstExpense = objResult.lstExpense || [];
                lstExpense.forEach((element: ItemFundAcc, index: number) => {
                    form.setValue(`lstExpense.${index}.sExpenseID`, element.sExpenseID)
                    form.setValue(`lstExpense.${index}.sName`, element.sName)
                    form.setValue(`lstExpense.${index}.isDisable`, element.isDisable)
                    form.setValue(`lstExpense.${index}.isOther`, element.isOther)
                    form.setValue(`lstExpense.${index}.isCanAdd`, element.isCanAdd)
                    form.setValue(`lstExpense.${index}.sTotal`, element.sTotal)
                });
                let sumExpense = _.sumBy(lstExpense, (o: ItemFundAcc) => { return parseFloatCheckValue(o.sTotal); });
                sumExpense = Number(sumExpense.toFixed(2));


                let calBalance = objResult.nBringForward + sumIncome - sumExpense;
                form.setValue("sBalance", calBalance + "")

                let nTotalMoreDetail = parseFloatCheckValue(form.getValues("sTotalMoreDetail")) ?? 0;
                setEqualBalance(calBalance === nTotalMoreDetail)
                form.setValue("lstIncome", lstIncome)
                form.setValue("lstExpense", lstExpense)
                form.setValue("lstMoreDetail", objResult.lstMoreDetail)
                setOptionExpense(objResult.lstOptionExpense || [])
                form.reset({
                    ...form.watch(),
                });
            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSelectExpense = async (Objvalue) => {
        if (!form.getValues("dDate") || !Objvalue || Objvalue?.isOther === true) {
            return null;
        }
        let dDateIncome = moment(form.getValues("dDate")).valueOf();
        let nValue = 0;
        DialogFn.BlockUI();
        await AxiosFn.Get(`FundAccounting/GetValueExpenseType`, { sTypeExpexseID: Objvalue.nFundExpenseID + "", nDate: dDateIncome }, (result) => {
            DialogFn.UnBlockUI();
            // if (result.nStatusCode === 203) {
            //     DialogFn.Warning("ไม่พบการบันทึกข้อมูลรายการ"+Objvalue.label);
            //     return;
            // }
            let objResult = result.objResult;
            if (objResult) {
                nValue = objResult.nValue
                return nValue;
            }
        }, null, () => DialogFn.UnBlockUI());
        return nValue;
    };


    const findValue = (arrList, fieldChildren, fieldValue, value) => {
        for (let obj of arrList) {
            if (obj[`${fieldValue}`] === value) {
                return obj;
            }
            if (obj[`${fieldChildren}`]) {
                let result = findValue(
                    obj[`${fieldChildren}`],
                    fieldChildren,
                    fieldValue,
                    value
                );
                if (result) {
                    return result;
                }
            }
        }
        return undefined;
    };


    const findMaxID = (lstData) => {
        let arrInt: number[] = [];
        lstData.forEach((element) => {
            arrInt.push(element.nOrder);
            RecursiveGetID(element.lstSubLevel, arrInt);
        });
        let nMax = arrInt.length > 0 ? Math.max(...arrInt) + 1 : 1;
        return nMax;
    };

    const RecursiveGetID = (children, arrInt: number[]) => {
        if (children) {
            children.forEach((elementChild) => {
                arrInt.push(elementChild.nOrder);
                RecursiveGetID(elementChild.lstSubLevel, arrInt);
            });
        }
    };

    const objProvider = React.useMemo(() => (
        {
            isView,
            isSubmit,
            DialogFn,
            form,
            optionExpense,
            findValue,
            findMaxID,
            setEqualBalance,
            handleSelectExpense,
        } as IproviderFundAcc
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [isView, DialogFn, form, optionExpense]);


    return (
        <FormProvider {...form}>
            <ProviderFundAccount.Provider value={objProvider} >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <DatePickerItem
                            id={`dDate`}
                            name={`dDate`}
                            label={`ประจำเดือน-ปี`}
                            required
                            fullWidth
                            disabled={isView || !!objParamPath.ParamId}
                            IsMonthYearPicker
                            format="MMMM YYYY"
                            onChange={(eValue) => handleSelectYear(eValue)}
                        />
                    </Grid>
                    {objParamPath.ParamId && !isView && <Grid item>
                        <BtnBaseButton
                            sx={{ width: "100%" }}
                            startIcon={<CalculateRoundedIcon />}
                            txt="คำนวณใหม่"
                            id="btnRecalculate"
                            bgcolor="#139cd7"
                            bgcolorHover="#237ce0"
                            fontColor="#ffffff"
                            IsCircleWithOutText={false}
                            isFullwidth={true}
                            onClick={() => { ReCalculateValue() }}
                        />
                    </Grid>}
                    {isValueDate ? <Grid item xs={12}>
                        <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"end"}>
                            <Grid item >
                                <Typography>เงินคงเหลือ ณ วันต้นงวด</Typography>
                            </Grid>
                            <Grid item xs={12} sm={"auto"}>
                                <InputReactNumber
                                    id={`sBringForward`}
                                    name={`sBringForward`}
                                    required={false}
                                    disabled
                                    maxDigits={2}
                                />
                            </Grid>
                            <Grid item >
                                <Typography>บาท</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TableIncome />
                            </Grid>
                            <Grid item xs={12}>
                                <TableExpense />
                            </Grid>
                            <Grid item >
                                <Typography>เงินคงเหลือ ณ วันปลายงวด</Typography>
                            </Grid>
                            <Grid item xs={12} sm={"auto"}>
                                <InputReactNumber
                                    id={`sBalance`}
                                    name={`sBalance`}
                                    required={false}
                                    disabled
                                    maxDigits={2}
                                    IsCanMinus
                                />
                            </Grid>
                            <Grid item >
                                <Typography>บาท</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TableMoreDetail />
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    equalBalance ? null : <Typography color={"#ed1c24"} fontWeight={600} textAlign={"right"} paddingRight={"125px"}>ยอดเงินไม่ถูกต้อง</Typography>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                        :
                        <Grid item xs={12}>
                            <Typography textAlign={"center"} >ไม่พบข้อมูล</Typography>
                        </Grid>
                    }
                    <Grid item xs={12}></Grid>
                    <Grid item xs={12}>
                        {/* Button */}
                        <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                            alignItems={"start"}
                        >
                            <Grid item>
                                <BtnBack id={"btnback-fundaccount"} onClick={() => gotoBack()} />
                            </Grid>
                            <Grid item>
                                {!isValueDate || isView ? null :
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent={"end"}
                                        alignItems={"start"}
                                    >
                                        {!isSubmit && <Grid item>
                                            <BtnDraft
                                                id={"btndraft-fundaccount"}
                                                onClick={form.handleSubmit(() => handleSubmitForm("D"))}
                                            />
                                        </Grid>}
                                        <Grid item>
                                            <BtnSave
                                                id={"btnsave-fundaccount"}
                                                IsDisabled={!equalBalance}
                                                onClick={form.handleSubmit(() => handleSubmitForm("S"))}
                                            />
                                        </Grid>
                                    </Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

            </ProviderFundAccount.Provider>
        </FormProvider>

    )
}

export default FundAccoutingForm